import {graphql, useFragment} from 'react-relay'

import {getBuild, getBuildStatusIconFromBuild} from '../selectors'
import type {BuildId} from '../types'

import type {useBuildStatusIconFragment$key} from './__generated__/useBuildStatusIconFragment.graphql'
import {useAppSelector} from './react-redux'
import useMyId from './useMyId'

export function useBuildStatusIcon(buildId?: BuildId | null) {
  const myId = useMyId()
  return useAppSelector(state => {
    const build = getBuild(state, buildId)
    return getBuildStatusIconFromBuild(build, myId)
  })
}

const statusIconFragment = graphql`
  fragment useBuildStatusIconFragment on Build {
    status
    state
    canceledInfo {
      timestamp
    }
    failedToStart
    personal
    detachedFromAgent
    user {
      rawId
    }
  }
`

export function useBuildStatusIconRelay(buildKey: useBuildStatusIconFragment$key | null) {
  const myId = useMyId()
  const build = useFragment(statusIconFragment, buildKey)
  return getBuildStatusIconFromBuild({...build, user: {id: build?.user?.rawId}}, myId)
}
